module.exports = __webpack_public_path__ + "img/Ok-cuate.3c5b69d5.svg";